import styled from '@emotion/styled';
import theme from '../../constants/theme';

type HeadingProps = {
  textAlign?: string;
  fontSize?: string;
  fontWeight?: string;
  lineHeight?: string;
  color?: string;
  textTransform?: string;
  theme?: typeof theme;
  fontFamily?:string;
};

const Heading = styled.h1<HeadingProps>`
  font-style: normal;
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : 'Poppins')} !important;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 600)};
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}` : '54px')};
  line-height: ${(props) =>
    props.lineHeight ? `${props.lineHeight}` : '130%'};
  color: ${(props) => (props.color ? props.color : '#232323')};
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'left')};
  text-transform: ${(props) =>
    props.textTransform ? props.textTransform : 'auto'};
`;

export default Heading;
